import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=12a1b777&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"
import style0 from "./cancel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports